import React from "react";
import { Crosshair } from "lucide-react";
import { Link } from "react-router-dom";

export default function Nav({ onCtaClick }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#050505]/75 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 text-white tracking-tight"
        >
          <span className="relative inline-flex items-center justify-center w-7 h-7 border border-[#FF5000]">
            <Crosshair className="w-4 h-4 text-[#FF5000]" />
            <span className="absolute -top-[3px] -left-[3px] w-1.5 h-1.5 bg-[#FF5000]" />
          </span>
          <span className="font-semibold text-[15px]">
            Data<span className="text-[#FF5000]">Sniper</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/report"
            data-testid="nav-datasnipe-link"
            className="text-[13px] uppercase tracking-[0.18em] text-[#FF5000] hover:text-[#FF7333] transition-colors"
          >
            DataSnipe
          </Link>
          <button
            data-testid="nav-faq-link"
            onClick={() => scrollTo("faq")}
            className="text-[13px] uppercase tracking-[0.18em] text-neutral-400 hover:text-white transition-colors"
          >
            FAQ
          </button>
        </nav>

        <button
          data-testid="nav-request-access-btn"
          data-cta="true"
          onClick={onCtaClick}
          className="group inline-flex items-center gap-2 bg-[#FF5000] hover:bg-[#FF7333] text-white text-[13px] font-medium px-4 py-2 transition-all duration-200"
        >
          <span className="w-1.5 h-1.5 bg-white ds-pulse" />
          Join the Community
        </button>
      </div>
    </header>
  );
}
